module.exports = __webpack_public_path__ + "img/TRX.760fdf0a.png";